'use strict';
import {ACTIVE_TIMERS_LIST_PREFIX as prefix} from '../redux/state';

const START_TIMER = `${prefix}/START_TIMER`;
const PAUSE_TIMER = `${prefix}/PAUSE_TIMER`;
const STOP_TIMER = `${prefix}/STOP_TIMER`;
const UPDATE_TIMER_GPS = `${prefix}/UPDATE_TIME_GPS`;

/**
 * @param {StartTimerPayload} payload
 * @return {ReduxAction<StartTimerPayload>}
 */
export function startTimer(payload) {
  return {
    type: START_TIMER,
    payload: payload || {},
  };
}
startTimer.TYPE = START_TIMER;

/**
 * @param {StopTimerPayload} payload
 * @return {ReduxAction<StopTimerPayload>}
 */
export function pauseTimer(payload) {
  return {
    type: PAUSE_TIMER,
    payload: payload || {},
  };
}
pauseTimer.TYPE = PAUSE_TIMER;

/**
 * make a stop request
 *
 * remove the target from the local active timer list as not active
 *
 * @param {StopTimerPayload} payload
 * @return {ReduxAction<StopTimerPayload>}
 */
export function stopTimer(payload) {
  return {
    type: STOP_TIMER,
    payload: payload || {},
  };
}
stopTimer.TYPE = STOP_TIMER;

/**
 * @param {UpdatePositionPayload} payload
 * @return {ReduxAction<UpdatePositionPayload>}
 */
export function updateTimerGps(payload) {
  return {
    type: UPDATE_TIMER_GPS,
    payload: payload || {},
  };
}
updateTimerGps.TYPE = UPDATE_TIMER_GPS;

/**
 * @typedef {Object} ActiveTimer
 * @property {String} [id]
 * @property {String} [requestId]
 * @property {DomainLink} target
 * @property {String} parentName
 * @property {ActiveTimer#intervals} intervals
 * @property {?Number} startedAt
 * @property {?Number} endedAt
 * @property {Number} totalTime
 * @property {Boolean} locCap
 * @property {Array<ActiveTimer#GPSEntry>} loc
 * @property {SyncStatus} syncStatus
 * @property {GpsStatus} gpsStatus
 */

/**
 * @typedef {Array<ActiveTimer#interval>} ActiveTimer#intervals
 */

/**
 * @typedef {Object} ActiveTimer#interval
 * @property {Number} start
 * @property {Number} end
 * @property {String} id The id of the timer-activity associated with the time interval
 */

/**
 * @typedef {Object} ActiveTimer#GPSEntry
 * @property {Number} tim The time the entry was captured
 * @property {Number} [lat] Latitude
 * @property {Number} [lon] Longitude
 * @property {Number} [acc] Accuracy in meters
 * @property {Number} [alt] Altitude in meters
 * @property {Number} [altAcc] Altitude accuracy in meters
 * @property {Number} [head] Heading in degrees from true north, clockwise
 * @property {Number} [speed] Speed in meters per second
 * @property {String} [val] Human readable location
 */

/**
 * @typedef {Object} StartTimerPayload
 * @property {String} [id]
 * @property {String} requestId
 * @property {Number} startedAt
 * @property {String} [targetId] Required on initial creation
 * @property {String} [targetCollection] Required on initial creation
 * @property {String} [targetName] Required on initial creation
 * @property {String} [parentName] Required on initial creation
 */

/**
 * @typedef {Object} StopTimerPayload
 * @property {String} requestId
 * @property {String} [id] Database ID
 * @property {Number} endedAt
 */

/**
 * @typedef {Object} ActiveTimersActions
 * @property {Function|ReduxActionCreator<StartTimerPayload>} startTimer
 * @property {Function|ReduxActionCreator<StopTimerPayload>} pauseTimer
 * @property {Function|ReduxActionCreator<StopTimerPayload>} stopTimer
 * @property {Function|ReduxActionCreator<UpdatePositionPayload>} updateTimerGps
 */



// WEBPACK FOOTER //
// ./src/js/timers/actions/activeTimersActions.js